var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"x-small":""},on:{"click":_vm.open}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-magnify")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }